



























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Destroyed, Mounted } from '../decorators';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName } from '../../core/utils';
@Component({
    components: {}
})
export default class CloseConfirmationModal extends Vue {
    dialog: boolean = false;
    resolve: any = null;
    reject: any = null;
    message: any = null;
    title: any = null;
    options: any = {
        color: 'orange lighten-2',
        width: 400,
        zIndex: 200,
        noconfirm: false
    };

    myMethod(event) {
        if (event.keyCode === 27) {
            this.cancel();
        }
    }

    open(title, message, options?) {
        this.dialog = true;
        this.title = title;
        this.message = message;
        this.options = Object.assign(this.options, options);
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    mounted() {
        this.clickAction();
    }

    clickAction() {
        this.open('Mensaje de confirmación', '¿Está seguro que desea salir? Se perderán los cambios');
    }

    agree() {
        this.resolve(true);
        this.dialog = false;
        this.$emit('confirm-yes');
    }

    cancel() {
        this.resolve(false);
        this.dialog = false;
        this.$emit('confirm-no');
    }
}
